var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource',{attrs:{"resource":"coupon","resourceName":"Gutschein","attributes":[
    {
      name: 'slug',
      label: 'Code',
      type: 'CodeSelector'
    },
    {
      name: 'start',
      label: 'Start',
      type: 'DateTimeSelector',
      value: _vm.moment().format('YYYY-MM-DD HH:mm:ss')
    },
    {
      name: 'end',
      label: 'Ende',
      type: 'DateTimeSelector',
      value: _vm.moment()
        .add(1, 'weeks')
        .format('YYYY-MM-DD HH:mm:ss')
    },
    {
      name: 'amount',
      label: 'Menge an Coins'
    },
    {
      name: 'for_one',
      label: 'Einmal einlösbar?',
      type: 'CheckboxSelector',
      value: false
    },
    {
      name: 'active',
      label: 'Aktiv?',
      type: 'CheckboxSelector',
      value: false
    }
  ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Gutschein erstellen")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }